import styled from 'styled-components';

// Page-level form wrapper for the Payroll Date onboarding step.
// Uses min-height to push the sticky footer (Back / Save & Next) to the
// bottom of the viewport when the form's content is short.
export const StyledForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 200px);
`;
